import { c as _c } from "react/compiler-runtime";
const SIZES = {
  medium: 48,
  large: 80
} as const;
const COLORS = {
  green: '#009639',
  yellow: '#F3D03E',
  red: '#EF3340',
  no_data: '#ADADAD'
} as const;
const POINTER_DIRECTIONS = {
  same: 0,
  up: -45,
  down: 45
} as const;
const ARROW_PATH: Record<keyof typeof SIZES, string> = {
  medium: 'M40 24.25L37.25 21.5L28.5 12.5L22.75 12.5L32.25 22.25L8 22.25L8 26.25L32.5 26.25L22.75 36L28.5 36L37.25 27L40 24.25Z',
  large: 'M67 40.4219L62.3594 35.7812L47.5937 20.5938L37.8906 20.5938L53.9219 37.0469L13 37.0469L13 43.7969L54.3437 43.7969L37.8906 60.25L47.5938 60.25L62.3594 45.0625L67 40.4219Z'
};
const QUESTION_PATH: Record<keyof typeof SIZES, string> = {
  medium: 'M25.112 11.282C29.804 11.282 32.932 13.798 32.932 17.844C32.932 20.666 31.334 22.026 28.648 24.338C27.118 25.63 26.166 26.412 25.928 27.874L25.826 28.52H21.916V27.806C21.916 25.46 22.052 24.44 25.282 21.72C26.744 20.462 28.172 19.544 28.172 17.912C28.172 16.382 26.88 15.396 24.942 15.396C23.072 15.396 21.576 16.314 19.298 18.014L16.68 14.92C19.468 12.438 22.086 11.282 25.112 11.282ZM26.37 31.07V36H21.542V31.07H26.37Z',
  large: 'M42.044 19.084C50.048 19.084 55.384 23.376 55.384 30.278C55.384 35.092 52.658 37.412 48.076 41.356C45.466 43.56 43.842 44.894 43.436 47.388L43.262 48.49H36.592V47.272C36.592 43.27 36.824 41.53 42.334 36.89C44.828 34.744 47.264 33.178 47.264 30.394C47.264 27.784 45.06 26.102 41.754 26.102C38.564 26.102 36.012 27.668 32.126 30.568L27.66 25.29C32.416 21.056 36.882 19.084 42.044 19.084ZM44.19 52.84V61.25H35.954V52.84H44.19Z'
};
export type StatusArrowProps = {
  pointerDirection?: keyof typeof POINTER_DIRECTIONS | null;
  size: keyof typeof SIZES;
  variant?: keyof typeof COLORS | null;
  type?: 'arrow' | 'question';
  className?: string;
};
export const StatusArrow = t0 => {
  const $ = _c(14);
  const {
    size,
    variant,
    pointerDirection,
    type: t1,
    className
  } = t0;
  const type = t1 === undefined ? "arrow" : t1;
  const arrowSize = SIZES[size];
  const color = COLORS[variant || "no_data"];
  const rotation = POINTER_DIRECTIONS[pointerDirection || "same"];
  if (!arrowSize || !color) {
    console.error("Invalid props for StatusArrow");
    return null;
  }
  if (type === "arrow" && rotation == null) {
    console.error("Invalid pointerDirection for arrow");
    return null;
  }
  const t2 = `0 0 ${arrowSize} ${arrowSize}`;
  let t3;
  if ($[0] !== arrowSize || $[1] !== color) {
    t3 = <rect width={arrowSize} height={arrowSize} rx="5" fill={color} />;
    $[0] = arrowSize;
    $[1] = color;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== arrowSize || $[4] !== rotation || $[5] !== size || $[6] !== type) {
    t4 = type === "arrow" ? <path transform={`rotate(${rotation} ${arrowSize / 2} ${arrowSize / 2})`} d={ARROW_PATH[size]} fill="white" /> : <path d={QUESTION_PATH[size]} fill="white" />;
    $[3] = arrowSize;
    $[4] = rotation;
    $[5] = size;
    $[6] = type;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== arrowSize || $[9] !== className || $[10] !== t2 || $[11] !== t3 || $[12] !== t4) {
    t5 = <svg className={className} width={arrowSize} height={arrowSize} viewBox={t2} fill="none" xmlns="http://www.w3.org/2000/svg">{t3}{t4}</svg>;
    $[8] = arrowSize;
    $[9] = className;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
};